import { defineStore } from 'pinia';
import mapboxgl from 'mapbox-gl';

export const MapStore = defineStore({
  id: 'map', // id必填
  state: () => {
    return {
      MapTarget: mapboxgl.Map as any
    }
  }
})